import React, { Component } from 'react';

import { Row, Col } from 'react-bootstrap';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import 'FielderUtils/style.css';
import './InfoNewModules.css';

const _ = require('lodash');

class InfoTaskVariables extends Component {
	VariableField = (varProps) => {
		return (
			<Row>
				{varProps.element.type == 1 ? (
					<Col sm={12} className='mt-2'>
						<span className='title-padding text-title'>{varProps.element.name}</span>
						<input
							type='text'
							key={'input-' + varProps.index + '-'}
							className='form-control mt-1 text-left'
							placeholder={varProps.element.name}
							defaultValue={varProps.element.value ? varProps.element.value : ''}
							name='name'
							onChange={(e) => this.handleVariableFields(e, varProps.index, varProps.element.type)}
						/>
					</Col>
				) : (
					<Col sm={12} className='mt-2'>
						<span className='title-padding text-title'>{varProps.element.name}</span>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <TimePicker
                label={varProps.element.name}
                value={varProps.element.value ? new Date(`1970-01-01T${varProps.element.value}`) : null}
                onChange={(newValue) => {
                  const formatted = newValue
                    ? newValue.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
                    : '00:00';
                  this.handleVariableFields(formatted, varProps.index, varProps.element.type);
                }}
                renderInput={(params) => <TextField {...params} fullWidth size="small" />}
              />
            </LocalizationProvider>
					</Col>
				)}
			</Row>
		);
	};

	handleVariableFields = (event, index, type) => {
		const re = /^[0-9\b]+$/;
		let value = null;

		if (type == 1) {
			if (event.target.value === '' || re.test(event.target.value)) {
				value = event.target.value;
			}
		} else {
			value = event;
		}

		if (value) {
			this.props.taskType.routeVariables[index]['value'] = value;
		}
	};

	render() {
		return (
			<Col sm={12}>
				{this.props.taskType.routeVariables.map((element, index) => (
					<this.VariableField
						element={element}
						index={index}
						changeType={this.changeType}
						onChange={this.handleInputFields}
						id={'field-' + index}
						key={'field-' + index}
					/>
				))}
			</Col>
		);
	}
}

export default InfoTaskVariables;
